import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import HelmetWrapper from '../../components/common/HelmetWrapper';
import DeadlyCrossingNav from './DeadlyCrossingNav';

/**
 * Public store landing for Deadly Crossing (Zok Labs) — App Store / Play links.
 */
const DeadlyCrossingHomePage = () => {
  return (
    <PageLayout>
      <HelmetWrapper>
        <title>Deadly Crossing</title>
        <meta
          name="description"
          content="Deadly Crossing — a mobile jungle-crossing survival game by Zok Labs. Privacy Policy and Support."
        />
        <meta name="robots" content="noindex,follow" />
      </HelmetWrapper>

      <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border p-8">
            <DeadlyCrossingNav />
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Deadly Crossing</h1>
            <p className="text-gray-700 text-lg mb-8">
              A mobile jungle-crossing survival game by Zok Labs.
            </p>
            <ul className="space-y-3 text-base">
              <li>
                <Link
                  to="/deadly-crossing/privacy"
                  className="text-emerald-600 hover:text-emerald-800 hover:underline font-medium"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/deadly-crossing/support"
                  className="text-emerald-600 hover:text-emerald-800 hover:underline font-medium"
                >
                  Support
                </Link>
              </li>
            </ul>
            <p className="mt-10 text-sm text-gray-500">Publisher: Zok Labs · Last updated: August 2026</p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default DeadlyCrossingHomePage;
